"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _clientAwsS = require("@devsta/client-aws-s3");

var _clientAuth = require("@devsta/client-auth");

var _reactGlobalConfiguration = _interopRequireDefault(require("react-global-configuration"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _OutputBlock = _interopRequireDefault(require("./OutputBlock"));

var _GeneralInfo = _interopRequireDefault(require("./GeneralInfo"));

var _VideoOverview = _interopRequireDefault(require("./VideoOverview"));

var _SectionHeader = _interopRequireDefault(require("../../../common/components/SectionHeader"));

var _RejectionReasonsModal = _interopRequireDefault(require("./RejectionReasonsModal"));

var _ClosableSection = _interopRequireDefault(require("../../../common/components/ClosableSection"));

var _ContentPlaceholder = _interopRequireDefault(require("./ContentPlaceholder"));

require("../styles/_manage-video.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MOCK_VIDEO = {
  creditsTotal: 12,
  creditsUsed: 8,
  difficultyRating: 'EASY',
  linkedResources: [],
  attachments: []
};

var ManageVideo = /*#__PURE__*/function (_Component) {
  _inherits(ManageVideo, _Component);

  var _super = _createSuper(ManageVideo);

  function ManageVideo() {
    var _this;

    _classCallCheck(this, ManageVideo);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (internalNotes) {
      return function () {
        _this.setState({
          modalInternalNotes: internalNotes
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "downloadAllAssets", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var serviceEndpoint, video, videoId, _credentials$get, token, aTag;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              serviceEndpoint = _reactGlobalConfiguration.default.get('serviceEndpoint');
              video = _this.state.video;

              if (video) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              videoId = video.videoId;
              _credentials$get = _clientAuth.credentials.get(), token = _credentials$get.token;
              aTag = document.createElement('a');
              aTag.setAttribute('style', 'display:none');
              aTag.setAttribute('href', "".concat(serviceEndpoint, "export/downloads?videoId=").concat(videoId, "&t=").concat(token));
              aTag.click();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onSubmitInternal", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(outputId) {
        var submitInternal, video, masterOutput, relatedOutputs, updatedMaster, updatedOutputs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                submitInternal = _this.props.submitInternal;
                video = _this.state.video;

                if (video) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                masterOutput = video.masterOutput, relatedOutputs = video.relatedOutputs;
                _context2.next = 7;
                return submitInternal({
                  outputId: outputId
                });

              case 7:
                updatedMaster = outputId === masterOutput.outputId ? _objectSpread({}, masterOutput, {
                  status: {
                    name: 'INTERNAL_REVIEW'
                  }
                }) : masterOutput;
                updatedOutputs = relatedOutputs.map(function (output) {
                  var thisOutputId = output.outputId;

                  if (thisOutputId === outputId) {
                    return _objectSpread({}, output, {
                      status: {
                        name: 'INTERNAL_REVIEW'
                      }
                    });
                  }

                  return output;
                });
                return _context2.abrupt("return", void _this.setState({
                  video: _objectSpread({}, video, {
                    masterOutput: updatedMaster,
                    relatedOutputs: updatedOutputs
                  })
                }));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onViewFullBrief", function () {
      var history = _this.props.history;
      var video = _this.state.video;

      if (!video) {
        return;
      }

      var videoId = video.videoId;
      history.rootPush("/video-tool/builder/".concat(videoId));
    });

    _defineProperty(_assertThisInitialized(_this), "fetchVideo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props, getVideo, fetchAssetsForResource, apolloClient, _yield$getVideo, data, error, outputs, masterOutputIndex, masterOutput, relatedOutputs, presenters, video;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, getVideo = _this$props.getVideo, fetchAssetsForResource = _this$props.fetchAssetsForResource, apolloClient = _this$props.apolloClient;
              _context3.next = 3;
              return getVideo();

            case 3:
              _yield$getVideo = _context3.sent;
              data = _yield$getVideo.data;
              error = _yield$getVideo.error;

              if (!(!data || error)) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", void _this.setState({
                error: error || 'error'
              }));

            case 8:
              if (data.getVideo) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return", void _this.setState({
                video: null
              }));

            case 10:
              outputs = data.getVideo.outputs;
              masterOutputIndex = outputs.findIndex(function (_ref4) {
                var isMaster = _ref4.isMaster;
                return isMaster;
              });
              masterOutput = outputs[masterOutputIndex];
              relatedOutputs = Array.from(outputs);
              relatedOutputs.splice(masterOutputIndex, 1);
              _context3.next = 17;
              return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                apiClient: apolloClient,
                dataArray: data.getVideo.presenters.map(function (presenter) {
                  return _objectSpread({}, presenter, {
                    organisationId: data.getVideo.organisationId
                  });
                }),
                substitutedKeys: ['imageKey']
              });

            case 17:
              presenters = _context3.sent;
              video = _objectSpread({}, MOCK_VIDEO, {}, data.getVideo, {
                presenters: presenters,
                masterOutput: masterOutput,
                relatedOutputs: relatedOutputs
              });
              fetchAssetsForResource({
                data: video,
                resourceId: video.videoId,
                organisationId: video.organisationId
              });

              _this.setState({
                video: video
              });

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "updateVideoData", function (payload) {
      var video = _this.state.video;

      _this.setState(_objectSpread({}, video, {}, payload));
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modalInternalNotes: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragOver", function (e) {
      e.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragLeave", function (e) {
      var dropZoneDisplayed = _this.state.dropZoneDisplayed;

      if (!_this._manageVideoRef) {
        return void _this.setState({
          dropZoneDisplayed: false
        });
      }

      var rect = _this._manageVideoRef.getBoundingClientRect();

      var hideDropZone = e.clientY < rect.top || e.clientY >= rect.bottom || e.clientX <= rect.left || e.clientX >= rect.right;

      if (!hideDropZone || !dropZoneDisplayed) {
        return;
      }

      _this.setState({
        dropZoneDisplayed: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragEnter", function () {
      _this.setState({
        dropZoneDisplayed: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDropZone", function (e) {
      e.preventDefault();

      _this.setState({
        dropZoneDisplayed: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setManageVideoRef", function (ref) {
      if (!ref) {
        return;
      }

      _this._manageVideoRef = ref;
    });

    _this.state = {
      dropZoneDisplayed: false
    };
    return _this;
  }

  _createClass(ManageVideo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchVideo();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var history = this.props.history;
      var _this$state = this.state,
          video = _this$state.video,
          error = _this$state.error,
          modalInternalNotes = _this$state.modalInternalNotes,
          dropZoneDisplayed = _this$state.dropZoneDisplayed;

      if (error) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.Error, null);
      }

      if (video === void 0) {
        return /*#__PURE__*/_react.default.createElement(_ContentPlaceholder.default, null);
      }

      if (!video) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.NotFound, null);
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "manage-video page",
        onDrop: this.closeDropZone,
        onDragLeave: this.handleDragLeave,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragOver,
        ref: this.setManageVideoRef
      }, /*#__PURE__*/_react.default.createElement(_RejectionReasonsModal.default, {
        visible: Boolean(modalInternalNotes),
        onClose: this.closeModal,
        rejectionReasons: modalInternalNotes
      }), /*#__PURE__*/_react.default.createElement(_uiKit.PageHeader, {
        title: video.name,
        subtitle: "Video Queue",
        actionBtnText: "View Full Brief",
        actionBtnOnClick: this.onViewFullBrief,
        secondaryContent: /*#__PURE__*/_react.default.createElement(_uiKit.ActionButton, {
          icon: "export",
          iconSize: 25,
          iconColor: "regent",
          onClick: this.downloadAllAssets
        })
      }), /*#__PURE__*/_react.default.createElement(_commonReact.AssetsSelector, {
        assetIds: video.assetIds
      }, function (assets) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "page__content"
        }, /*#__PURE__*/_react.default.createElement(_GeneralInfo.default, {
          video: video,
          assets: assets,
          updateVideoData: _this2.updateVideoData
        }), /*#__PURE__*/_react.default.createElement(_ClosableSection.default, {
          title: "Video Overview"
        }, /*#__PURE__*/_react.default.createElement(_VideoOverview.default, {
          history: history,
          assets: assets,
          video: video
        })), /*#__PURE__*/_react.default.createElement(_ClosableSection.default, {
          title: "Deliverables"
        }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SectionHeader.default, {
          iconName: "brief",
          title: "Master Output"
        }), /*#__PURE__*/_react.default.createElement(_OutputBlock.default, {
          output: video.masterOutput,
          video: video,
          submitInternal: _this2.onSubmitInternal,
          onViewInternalNotes: _this2.openModal,
          dropZoneDisplayed: dropZoneDisplayed
        }), video.relatedOutputs.length ? /*#__PURE__*/_react.default.createElement(_SectionHeader.default, {
          marginTop: true,
          iconName: "brief",
          title: "Related Outputs",
          btnText: "Add New Video",
          hideButton: !(0, _commonReact.hasPermission)('UPDATE', video.permissions)
        }) : null, video.relatedOutputs.map(function (output) {
          return /*#__PURE__*/_react.default.createElement(_OutputBlock.default, {
            key: output.outputId,
            output: output,
            video: video,
            submitInternal: _this2.onSubmitInternal,
            onViewInternalNotes: _this2.openModal,
            dropZoneDisplayed: dropZoneDisplayed
          });
        }))));
      }));
    }
  }]);

  return ManageVideo;
}(_react.Component);

var _default = ManageVideo;
exports.default = _default;